var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tq-image',{staticClass:"TQ_clickable TQ_verticalAlignMiddle",attrs:{"pb_src_r":_vm.ass_img_copy2_b},nativeOn:{"click":function($event){return _vm.m_copyText_f($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }